import { Injectable } from '@angular/core';
import { HttpClient, HttpBackend } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Observable, of } from 'rxjs';
import { tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class DataService {
  site_link : String;
  invisibleCaptchaKey: string;
  verifyCaptchaApi = environment.KUDOSHUB_BACKEND_HOST + 'api/verify-recaptcha?token=';
  getWebDevServicesApi = environment.KUDOSHUB_BACKEND_HOST + 'api/get-web-development-services';
  getMobileDevServicesApi = environment.KUDOSHUB_BACKEND_HOST + 'api/get-mobile-app-development-services';
  webDevQuoteApi = environment.KUDOSHUB_BACKEND_HOST + 'api/create-web-development-quote';
  mobileDevQuoteApi = environment.KUDOSHUB_BACKEND_HOST + 'api/create-mobile-app-development-quote';
  getInTouchApi = environment.KUDOSHUB_BACKEND_HOST + 'api/create-query';
  getJobPostsApi = environment.KUDOSHUB_BACKEND_HOST + '/api/get-all-posts';
  createJobInquiryApi = environment.KUDOSHUB_BACKEND_HOST + '/api/create-job-enquiry';
    //request -enterprises quote
    readonly requestEnterprisesApi = environment.KUDOSHUB_BACKEND_HOST+"api/request-enterprise-quote";

  public responseCache = new Map();

  constructor(private http: HttpClient, private handler: HttpBackend) {
    this.http = new HttpClient(this.handler);
   }

  getTimeZone(): Observable<any> {
    const URL = environment.KUDOSHUB_BACKEND_HOST + 'api/timezone';
    const fromCache = this.responseCache.get(URL);
    if (fromCache) {
      return of(fromCache);
    }
    const response = this.http.get<any>(URL);
    //You can also use map instead of tap
    return response.pipe(
          tap(res => {
               this.responseCache.set(URL, res)
           })
         );
  }

  siteLink() {
    return this.site_link  = environment.KUDOSHUB_IMAGE_URL;
  }

  invisibleCaptchaSiteKey() {
    return this.invisibleCaptchaKey = environment.KUDOSHUB_InvisibleCaptchaSiteKey;
  }

  visibleCaptchaSiteKey() {
    return environment.KUDOSHUB_VisibleCaptchaSiteKey;
  }

  verifyCaptcha(token: string){
    return this.http.get(this.verifyCaptchaApi+token);
  }
  
  getWebDevServices() {
    return this.http.get(this.getWebDevServicesApi);
  }

  getMobileAppDevServices() {
    return this.http.get(this.getMobileDevServicesApi);
  }

  webDevQuote(userDetails: any) {
    return this.http.post(this.webDevQuoteApi, userDetails);
  } 

  mobileDevQuote(userDetails: any) {
    return this.http.post(this.mobileDevQuoteApi, userDetails);
  }

  getInTouchQuery(userDetails: any) {
    return this.http.post(this.getInTouchApi, userDetails);
  }
  
  getJobPosts() {
    return this.http.get(this.getJobPostsApi);
  }

  createJobEnquiry(formDetails: any) {
    return this.http.post(this.createJobInquiryApi, formDetails);
  }

  requestEnterprisesQuoteApi(formDetails:any){
    return this.http.post(this.requestEnterprisesApi, formDetails);
  }

}
